/*global window, jQuery, calendar */
(function($) {

  'use strict';

  $(function() {

  	var Shuffle = window.Shuffle;
		var element = document.querySelector('.shuffle-container');
		
		var shuffleInstance = new Shuffle(element, {
		  itemSelector: '.myitem',
		  sizer: '.my-sizer-element',
		});
		
		shuffleInstance.filter(Shuffle.ALL_ITEMS);


  	$('.filter').on('change', function(){
  		console.log(this.value);
  		shuffleInstance.filter(this.value);

  	})

  	


  });



}(jQuery));
